import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	ChartData,
} from "chart.js";
import {
	AffiliateMonthData,
	AffiliateMonthlyHistory,
} from "../../types/affiliate/affiliate";
import Select from "react-select";
import { useTranslationProvider } from "../../providers/TranslationProvider";
interface OptionType {
	value: string;
	label: string;
}
ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend
);

const AffiliateMonthlyChart = ({
	monthlyHistory,
}: {
	monthlyHistory: AffiliateMonthlyHistory;
}) => {
	const { language } = useTranslationProvider();
	const labels = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	const itaLabels = [
		"Gennaio",
		"Febbraio",
		"Marzo",
		"Aprile",
		"Maggio",
		"Giugno",
		"Luglio",
		"Agosto",
		"Settembre",
		"Ottobre",
		"Novembre",
		"Dicembre",
	];
	const encounteredValues = new Set(); // Using a Set for efficient lookup

	const years = monthlyHistory.monthlyHistory
		.map((data: AffiliateMonthData) => {
			const yearValue = data.monthId.split("_")[0];
			if (encounteredValues.has(yearValue)) {
				return undefined;
			} else {
				encounteredValues.add(yearValue);
				return {
					value: yearValue,
					label: yearValue,
				};
			}
		})
		.filter((year) => year !== undefined); // Filter out undefined values, if any

	years.push({ label: "2023", value: "2023" });

	const [selectedYear, setSelectedYear] = useState<OptionType | null>({
		label: "2024",
		value: "2024",
	});

	const filteredData = monthlyHistory.monthlyHistory.filter(
		(data: AffiliateMonthData) =>
			selectedYear != null
				? data.monthId.startsWith(selectedYear.value)
				: ""
	);

	const labelToUse: string[] = language == "it" ? itaLabels : labels;
	const monthLabels: string[] = labelToUse.map(
		(month, index) => `${month} ${selectedYear?.label}`
	);

	const data: ChartData<"bar"> = {
		labels: monthLabels,
		datasets: [
			{
				label: language == "it" ? "Ricavi" : "Revenue",
				data: Array(12)
					.fill(0)
					.map((_, index) => {
						const monthData = filteredData.find(
							(data) =>
								Number(data.monthId.split("_")[1]) === index + 1
						);
						return monthData ? monthData.amount / 100 : 0;
					}),
				backgroundColor: "#147A7A",
			},
		],
	};
	const options = {
		responsive: true,
		aspectRatio: window.innerWidth < 600 ? 9 / 16 : undefined,
		maintainAspectRatio: window.innerWidth < 600 ? true : undefined,
		plugins: {
			legend: { position: "top" as const },
			title: {
				display: true,
				text: language == "it" ? "Ricavi" : "Revenue",
			},
		},
	};

	return (
		<div>
			<Select
				value={selectedYear}
				onChange={setSelectedYear}
				options={years as OptionType[]}
				defaultValue={years[0]}
				styles={{
					control: (baseStyles, state) => ({
						...baseStyles,
						borderColor: state.isFocused ? "#147A7A" : "gray",
					}),
				}}
				className="years-select"
				classNamePrefix="years-select-prefix"
			/>
			<Bar options={options} data={data} />
		</div>
	);
};

export default AffiliateMonthlyChart;
